import { memoize } from 'lodash';
import classnames from 'classnames';
import { COLORS } from 'Components/utils/color/colors';

const defaultValueSizes = {
  small: { w: '2.3rem', valueTextSize: 'text-md', labelTextSize: 'text-xxs' },
  large: { w: '3.0625rem', valueTextSize: 'text-2xl', labelTextSize: 'text-xs' },
};

export const themes = {
  default: memoize(({ size, color }) => {
    const textColor = color ? color : COLORS.WHITE;
    const textShadow = textColor === COLORS.WHITE ? 'text-shadow-2' : '';
    return {
      thRoot: 'flex rtl:flex-row items-stretch',
      thItem: `flex flex-col items-center justify-between mx-1 text-center text-${textColor}`,
      thLabel: `font-bold leading-one mb-1 ${textShadow} uppercase ${
        defaultValueSizes[size].labelTextSize
      }`,
      thValue: `flex font-bold items-center justify-center rounded-small text-center ${textShadow} leading-tight ${
        defaultValueSizes[size].valueTextSize
      }`,
      thValueStyle: {
        width: defaultValueSizes[size].w,
      },
    };
  }),
  offerPush: ({ color = COLORS.WHITE, bgColor }) => ({
    thRoot: classnames('flex rtl:flex-row items-stretch rounded-tiny px-1 font-brand', {
      [`text-${color}`]: true,
      [`bg-${bgColor}`]: !!bgColor,
    }),
    thItem: `flex items-center justify-center mx-px text-center text-${color}`,
    thLabel: 'leading-one uppercase text-xs',
    thValue: 'items-center justify-center rounded-small text-center leading-loose text-xs',
    thValueStyle: {
      width: 'auto',
    },
  }),
};
